import Vue from "vue";
import VueRouter from "vue-router";
import VueSession from "vue-session";
import VueSocialSharing from "vue-social-sharing";
import { authGuard } from "../auth";

Vue.use(VueSocialSharing);
Vue.use(VueSession);
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/SearchPage.vue"),
  },
  {
    path: "/login",
    name: "Home",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/homepage",
    name: "Homepage",
    component: () => import("../views/Homepage.vue"),
  },
  {
    path: "/addtor",
    name: "addtor",
    component: () => import("../views/addtorviews.vue"),
  },
  {
    path: "/addinvite",
    name: "addinvite",
    component: () => import("../views/addinviteviews.vue"),
  },
  {
    path: "/showdatatoradmin",
    name: "showdata",
    component: () => import("../views/showdatatorviews.vue"),
  },
  {
    path: "/linetoken",
    name: "line",
    component: () => import("../views/Line.vue"),
  },
  {
    path: "/ads",
    name: "ads",
    component: () => import("../views/Ads.vue"),
  },
  {
    path: "/user",
    name: "User",
    component: () => import("../views/User.vue"),
  },
  {
    path: "/showdatauser/:id",
    name: "showdatauser",
    component: () => import("../views/showdataviews.vue"),
  },
  {
    path: "/showdatainviteadmin",
    name: "showdatainvite",
    component: () => import("../views/showdatainviteviews.vue"),
  },
  {
    path: "/conferimadddata",
    name: "conferimad",
    component: () => import("../views/conferimadddataviews.vue"),
  },
  {
    path: "/newregist",
    name: "Regist",
    component: () => import("../views/Regist.vue"),
  },
  {
    path: "/listrefist",
    name: "ListRegist",
    component: () => import("../views/ListRegist.vue"),
  },
  {
    path: "/viewdetaildata/:id",
    name: "showInformationCustomerViews",
    component: () => import("../views/showInformationCustomerViews.vue"),
  },
  {
    path: "/listproject/:id",
    name: "listproject",
    component: () => import("../views/listproject.vue"),
  },
  {
    path: "/SearchPage",
    name: "SearchPage",
    component: () => import("../views/SearchPage.vue"),
  },
  {
    path: "/testviews",
    name: "testviews",
    component: () => import("../views/testviews.vue"),
  },
  {
    path: "/listcard",
    name: "ListCardPage",
    component: () => import("../views/ListCardPage.vue"),
  },
  {
    path: "/adduserviews",
    name: "adduserviews",
    component: () => import("../views/adduserviews.vue"),
  },
  {
    path: "/showuserviews",
    name: "showuserviews",
    component: () => import("../views/showuserviews.vue"),
  },
  {
    path: "/confirmlistdata",
    name: "confirmlistdata",
    component: () => import("../views/confirmlistdataviews.vue"),
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('../views/Profile.vue'),
    beforeEnter: authGuard
  },
  {
    path: "/showpartnersviews",
    name: "showpartnersviews",
    component: () => import("../views/showPartnersViews.vue"),
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
